var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-tooltip',_vm._b({attrs:{"content-class":"q-tooltip-content-class"}},'q-tooltip',_vm.computedProps,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }